/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Type of attachment event.
*/
export enum CloudResourceAttachmentEventType {
  ATTACHMENT_EVENT_TYPE_UNSPECIFIED = 'UNSPECIFIED',
  ATTACHMENT_EVENT_TYPE_ATTACH = 'ATTACH',
  ATTACHMENT_EVENT_TYPE_DETACH = 'DETACH'
}
